import { LayoutDashboard, Map, Presentation, Settings2, TableProperties } from 'lucide-react'

type ProjectView = 'cockpit' | 'table' | 'canvas' | 'presentation' | 'editor'

type ProjectViewNavProps = {
  active: ProjectView
  onCockpit: () => void
  onTable: () => void
  onCanvas: () => void
  onPresentation: () => void
  onEditor: () => void
}

export function ProjectViewNav({ active, onCockpit, onTable, onCanvas, onPresentation, onEditor }: ProjectViewNavProps) {
  return (
    <nav className="project-view-nav" aria-label="Vues du projet">
      <div>
        <button className={active === 'cockpit' ? 'active' : ''} onClick={onCockpit} type="button"><LayoutDashboard size={18} /> Cockpit</button>
        <button className={active === 'table' ? 'active' : ''} onClick={onTable} type="button"><TableProperties size={18} /> Tableau de suivi</button>
        <button className={active === 'canvas' ? 'active' : ''} onClick={onCanvas} type="button"><Map size={18} /> Parcours visuel</button>
        <button className={active === 'presentation' ? 'active' : ''} onClick={onPresentation} type="button"><Presentation size={18} /> Présentation du projet</button>
        <button className={active === 'editor' ? 'active' : ''} onClick={onEditor} type="button"><Settings2 size={18} /> Adapter ce parcours</button>
      </div>
    </nav>
  )
}
